import React from "react";
import PropTypes from "prop-types";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import {
  Container,
  Col,
  Button
} from "reactstrap";
import { canUseDOM } from "fbjs/lib/ExecutionEnvironment";
import humanizeDuration from "humanize-duration";
import ModalComponent from "~/components/ModalComponent";
import LinkComponent from "~/components/LinkComponent";

// external-global styles must be imported in your JS.
import styles from "./styles.scss";

const defaultStatistics = {
  best_playtime: 0
}

class WonModalComponent extends React.Component {
  static propTypes = {
    onRef: PropTypes.func.isRequired
  };

  constructor(props) {
    // Set props
    super(props);

    // Set initial state
    this.state = {
      playtime: PropTypes.number.isRequired
    };
  }

  //-----------------------------------------------------------------------
  // Lifecycle
  //-----------------------------------------------------------------------
  componentWillMount() {
    this.props.onRef(this);
  }

  componentWillUnmount() {
    this.props.onRef(undefined);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return false;
  }

  //-----------------------------------------------------------------------
  // Handlers
  //-----------------------------------------------------------------------
  showModal = () => {
    this.forceUpdate()

    // Show modal
    this.wonModalComponent.showModal();
  };

  hideModal = () => {
    // Show modal
    this.wonModalComponent.hideModal();

    // Stop confetti
    $.confetti.stop();
  };

  //-----------------------------------------------------------------------
  // Render
  //-----------------------------------------------------------------------
  render() {
    return (
      <ModalComponent
        className="won_modal_component"
        onRef={ref => {
          this.wonModalComponent = ref;
        }}
        onHideModal={this.hideModal}
      >
        <Container>
          <Col className="display_container">
            <h1>You solved the puzzle... well done!</h1>
            <p>Congratulations... you solved this puzzle in {is.undefined(this.state.playtime) ? 0 : humanizeDuration(this.state.playtime * 1000, { largest: 2 })}. Try again with more puzzle pieces or try to solve a new puzzle.</p>
          </Col>
          <Col className="button_container">
            <Button
              className="btn-lg"
              color="secondary"
              tag={LinkComponent}
              to={canUseDOM ? window.location.href : ''}
              addQueryParameters={true}
            >
              Restart puzzle game
            </Button>
          </Col>
          <Col className="button_container">
            <Button
              className="btn-lg"
              color="secondary"
              tag={LinkComponent}
              to={canUseDOM ? window.location.origin : ''}
              addQueryParameters={true}
            >
              Play a new puzzle game
            </Button>
          </Col>
        </Container>
      </ModalComponent>
    );
  }
}

export default withStyles(styles)(WonModalComponent);



// WEBPACK FOOTER //
// ./src/components/WonModalComponent/index.js